import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getTaxById } from "../../api/TaxService";
 
export default function ViewTax() {
  const location= useLocation();
  const id = location.state.taxId
  const [tax, setTax] = useState(null);
  const [loading, setLoading] = useState(false);
 
  const fetchTax = async () => {
    try {
      setLoading(true);
 
      const res = await getTaxById(id);
 
      if (res?.data?.data) {
        setTax(res.data.data);
      } else if (res?.data) {
        setTax(res.data);
      } else {
        setTax(res);
      }
    } catch (error) {
      setTax(null);
    } finally {
      setLoading(false);
    }
  };
 
  useEffect(() => {
    if (id) {
      fetchTax();
    }
  }, [id]);
 
  if (loading) {
    return (
      <div className="container py-3">
        <h5>Loading...</h5>
      </div>
    );
  }
 
  if (!tax) {
    return (
      <div className="container py-3">
        <h5>Tax Not Found</h5>
      </div>
    );
  }
 
  return (
    <div className="container py-3">
      <div className="row justify-content-center">
        <div className="col-md-7">
 
          <div className="card shadow-sm border-0">
 
            
 
            <div className="card-body p-0">
              <table className="table table-bordered mb-0">
                <tbody>
 
                  <tr>
                    <th style={{ width: "40%" }}>
                      Tax Name
                    </th>
                    <td>
                      {tax.taxName || "-"}
                    </td>
                  </tr>
 
                  <tr>
                    <th>
                      CGST Percentage (%)
                    </th>
                    <td>
                      {tax.cgstPercentage ?? 0}
                    </td>
                  </tr>
 
                  <tr>
                    <th>
                      SGST Percentage (%)
                    </th>
                    <td>
                      {tax.sgstPercentage ?? 0}
                    </td>
                  </tr>
 
                  <tr>
                    <th>
                      IGST Percentage (%)
                    </th>
                    <td>
                      {tax.igstPercentage ?? 0}
                    </td>
                  </tr>
 
                  <tr>
                    <th>
                      Total GST Percentage (%)
                    </th>
                    <td>
                      {tax.totalGstPercentage ?? 0}
                    </td>
                  </tr>
 
                  <tr>
                    <th>
                      Status
                    </th>
                    <td>
                      {tax.status || "Inactive"}
                    </td>
                  </tr>
 
                </tbody>
              </table>
            </div>
 
          </div>
 
        </div>
      </div>
    </div>
  );
}